import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const clover = defineConnector({
  identifier: "clover",
  name: "Clover",
  tagLine: "Point-of-sale system",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ apiHost }) => domainToRegex(apiHost),
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Clover instance details",
      items: [
        {
          kind: "markdown",
          content: "Enter the details for your Clover instance.",
        },
        {
          kind: "input",
          label: "Authorization Host",
          placeholder: "www.clover.com",
          required: true,
          target: { kind: "configuration", field: "authorizeHost" },
          helperText: "The Clover authorization hostname for your region.",
        },
        {
          kind: "input",
          label: "API Host",
          placeholder: "api.clover.com",
          required: true,
          target: { kind: "configuration", field: "apiHost" },
          helperText: "The Clover API hostname for your region.",
        },
      ],
    },
    {
      title: "Create a Clover app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Clover Developer Portal](https://www.clover.com/developers/) and create a new application to configure your OAuth settings and get your client credentials.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/clover/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Clover account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Clover account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: (configuration) =>
      `https://${configuration.authorizeHost}/oauth/v2/authorize`,
    tokenEndpoint: (configuration) =>
      `https://${configuration.apiHost}/oauth/v2/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.apiHost}/v3/merchants/current`,
  },
  publicEnvVars: ({ apiHost, authorizeHost }) => ({
    CLOVER_API_HOST: apiHost || "",
    CLOVER_AUTHORIZE_HOST: authorizeHost || "",
  }),
});
